
let portNumberLocal = localStorage.getItem('BondTimeportNoData');

let baseUrlToGiveBack = null

if (portNumberLocal) {

    // console.log("portNumber ", portNumberLocal)

    let portNumber = JSON.parse(portNumberLocal)

    // console.log("portNumber ", portNumber)

    baseUrlToGiveBack = portNumber[0].API_CONFIG

    console.log("baseUrlToGiveBack--> ", baseUrlToGiveBack)


}



export let base_url = baseUrlToGiveBack